// Unpublished Work © 2020-2024 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import {connect} from 'react-redux';
import {TOAST_TYPE} from 'Src/ui-core/constants/toast-constants';
import {joinClassNames} from 'Utils/html-utils';
import {useToast} from 'Src/ui-core/react-hooks/use-toast';
import {CONFLICT} from 'Common/constants/errors';
import {Dialog} from '@deere/isg.component-library';

function FormDialog(props) {
    const {
        cancelLabel,
        className,
        closeHandler,
        disableSave,
        hasRequiredFields = true,
        footerLoading,
        onSave,
        isMigrated,
        saveLabel,
        translations,
        width = 'sm',
        ...otherProps
    } = props;

    const {addToast} = useToast();

    const saveCallback = React.useCallback(async (event) => {
        try {
            await onSave(event);
        } catch (err) {
            if (err.response.status !== CONFLICT) {
                addToast({
                    message: translations.ERROR_OCCURRED_TITLE,
                    type: TOAST_TYPE.ERROR
                });
            }
        }
    }, [onSave, translations.ERROR_OCCURRED_TITLE]);

    const footerActions = [
        {
            onClick: closeHandler,
            variant: 'secondary',
            title: cancelLabel
        },
        {
            onClick: saveCallback,
            variant: 'primary',
            loading: footerLoading,
            disabled: disableSave,
            title: saveLabel
        }
    ];

    const footerMessage = hasRequiredFields ? `* = ${translations.REQUIRED}` : '';

    return (
        <Dialog
            {...otherProps}
            className={joinClassNames('form-dialog', className)}
            closeHandler={closeHandler}
            footerActions={footerActions}
            footerMessage={footerMessage}
            open={true}
            width={width}
        />
    );
}

FormDialog.propTypes = {
    cancelLabel: PropTypes.string.isRequired,
    className: PropTypes.string,
    closeHandler: PropTypes.func.isRequired,
    disableSave: PropTypes.bool,
    footerLoading: PropTypes.bool,
    hasRequiredFields: PropTypes.bool,
    isMigrated: PropTypes.bool,
    onSave: PropTypes.func.isRequired,
    saveLabel: PropTypes.string.isRequired,
    translations: PropTypes.translations,
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool
    ])

};

export function mapStateToProps(state) {
    return {
        isMigrated: state.membership.isMigrated
    };
}

export default connect(mapStateToProps)(FormDialog);
